import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-brand-dark text-white pt-16 pb-8 border-t-4 border-brand-wood">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          {/* Om virksomheden */}
          <div>
            <div className="mb-5 inline-block bg-white/95 p-3 rounded-xl shadow-xs">
              <img 
                src="https://assets.auxodev.dk/cdn-cgi/image/width=400,quality=90,format=auto/assets/2c036395-f6c9-48ce-982b-c0c810ba745b/logo-1.png" 
                alt="Tømrermester Mikkel Juler ApS Logo" 
                className="h-14 w-auto object-contain"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed mb-6">
              Din lokale tømrermester i Vester Nebel og omegn. Vi lægger vægt på godt, gedigent håndværk, ordentlig kommunikation og langsigtede løsninger til både private og erhverv.
            </p>
            <div className="flex gap-4">
              <a href="tel:+4528455012" className="w-10 h-10 rounded-xl bg-brand-dark-light hover:bg-brand-wood hover:text-brand-dark transition-all duration-200 flex items-center justify-center text-gray-300 hover:scale-105">
                <i className="fa-solid fa-phone" />
              </a>
              <a href="mailto:Mikkeljuler@gmail.com" className="w-10 h-10 rounded-xl bg-brand-dark-light hover:bg-brand-wood hover:text-brand-dark transition-all duration-200 flex items-center justify-center text-gray-300 hover:scale-105">
                <i className="fa-solid fa-envelope" />
              </a>
              <a href="https://maps.google.com/?q=Koldingvej+49B,+6040+Egtved" target="_blank" rel="noopener noreferrer" className="w-10 h-10 rounded-xl bg-brand-dark-light hover:bg-brand-wood hover:text-brand-dark transition-all duration-200 flex items-center justify-center text-gray-300 hover:scale-105">
                <i className="fa-solid fa-location-dot" />
              </a>
            </div>
          </div>

          {/* Hurtige links */}
          <div>
            <h3 className="text-brand-wood font-semibold text-md uppercase tracking-wider mb-5">Hurtige links</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-xs text-brand-wood" />
                  <span>Forside</span>
                </Link>
              </li>
              <li>
                <Link to="/projekter" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-xs text-brand-wood" />
                  <span>Projekter</span>
                </Link>
              </li>
              <li>
                <Link to="/om-mikkel" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-xs text-brand-wood" />
                  <span>Om Mikkel</span>
                </Link>
              </li>
              <li>
                <Link to="/kontakt" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-xs text-brand-wood" />
                  <span>Kontakt</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Vores ydelser */}
          <div>
            <h3 className="text-brand-wood font-semibold text-md uppercase tracking-wider mb-5">Vores ydelser</h3>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/ydelser/nyt-tag" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-xs text-brand-wood" />
                  <span>Nyt tag & tagrenovering</span>
                </Link>
              </li>
              <li>
                <Link to="/ydelser/terrasser" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-xs text-brand-wood" />
                  <span>Eksklusive træterrasser</span>
                </Link>
              </li>
              <li>
                <Link to="/ydelser/tilbygninger-renovering" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-xs text-brand-wood" />
                  <span>Tilbygninger & renovering</span>
                </Link>
              </li>
              <li>
                <Link to="/ydelser/doere-vinduer" className="text-gray-400 hover:text-white transition-colors duration-200 flex items-center gap-2">
                  <i className="fa-solid fa-chevron-right text-xs text-brand-wood" />
                  <span>Døre & vinduesudskiftning</span>
                </Link>
              </li>
            </ul>
          </div>

          {/* Åbningstider & Info */}
          <div>
            <h3 className="text-brand-wood font-semibold text-md uppercase tracking-wider mb-5">Åbningstider</h3>
            <ul className="space-y-3 text-sm text-gray-400">
              <li className="flex justify-between border-b border-brand-dark-light pb-1.5">
                <span>Mandag - Torsdag:</span>
                <span className="text-white font-medium">07:00 - 16:00</span>
              </li>
              <li className="flex justify-between border-b border-brand-dark-light pb-1.5">
                <span>Fredag:</span>
                <span className="text-white font-medium">07:00 - 14:00</span>
              </li>
              <li className="flex justify-between">
                <span>Lørdag - Søndag:</span>
                <span className="text-white font-medium">Lukket</span>
              </li>
              <li className="pt-4 text-xs text-gray-500 leading-relaxed">
                <i className="fa-solid fa-circle-info text-brand-wood mr-1.5" />
                Akutte opgaver uden for åbningstid kan aftales telefonisk.
              </li>
            </ul>
          </div>
        </div>

        {/* Bund-bar */}
        <div className="border-t border-brand-dark-light pt-8 flex flex-col sm:flex-row justify-between items-center gap-4 text-xs text-gray-500">
          <div>
            &copy; {currentYear} Tømrermester Mikkel Juler ApS. CVR: 42891045. Alle rettigheder forbeholdes.
          </div>
          <div className="flex gap-4">
            <span>Udviklet med fokus på kvalitet & SEO</span>
          </div>
        </div>
      </div>
    </footer>
  );
}
